import qs from 'qs';
import API from './config/axiosConfig'
//import {appInsights} from './appInsight'

/**
 * Implements a data fetcher using Axios - replace with your favorite
 * SSR-capable HTTP or fetch library if you like. See HttpJsonFetcher<T> type
 * in sitecore-jss library for implementation details/notes.
 * @param {string} url The URL to request; may include query string
 * @param {any} data Optional data to POST with the request.
 */
export const dataFetcher = async (url, data) => {
  //appInsights.trackEvent({ name: 'Layout Service Call', properties: { url } })
  return await API({
    url,
    method: data ? 'POST' : 'GET',
    data,
    withCredentials: true,
  });
}

export const postDataFetcher = async (url, data) => {
  //appInsights.trackEvent({ name: 'Custom Service Call', properties: { url, data } })
  return await API({
    url,
    method: 'POST',
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    data: qs.stringify(data),
    withCredentials: true,
  });
}
